module.exports = __webpack_public_path__ + "img/close-cross.ff619c36.svg";